var moduleMap = {
	"./app": () => {
		return Promise.all([__webpack_require__.e(9408), __webpack_require__.e(5908), __webpack_require__.e(7954), __webpack_require__.e(8130), __webpack_require__.e(8449), __webpack_require__.e(7023), __webpack_require__.e(6240), __webpack_require__.e(893), __webpack_require__.e(6150), __webpack_require__.e(3572), __webpack_require__.e(4385)]).then(() => (() => ((__webpack_require__(45182)))));
	},
	"./store": () => {
		return Promise.all([__webpack_require__.e(9408), __webpack_require__.e(5908), __webpack_require__.e(7954), __webpack_require__.e(8130), __webpack_require__.e(7023), __webpack_require__.e(6240), __webpack_require__.e(6150)]).then(() => (() => ((__webpack_require__(63709)))));
	},
	"./styles": () => {
		return Promise.all([__webpack_require__.e(3094), __webpack_require__.e(6838), __webpack_require__.e(1385)]).then(() => (() => ((__webpack_require__(11385)))));
	},
	"./registry": () => {
		return __webpack_require__.e(8022).then(() => (() => ((__webpack_require__(28022)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});